/* eslint-disable jsx-a11y/media-has-caption */
import { Box, CardMedia, Typography, useMediaQuery, useTheme } from "@mui/material";
import whyxane1 from "assets/video/whyxane1.mp4";
import whyxane2 from "assets/video/whyxane2.mp4";
import whyxane3 from "assets/video/whyxane3.mp4";
import React from "react";

export default function WhyXane() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: "36px",
      }}
    >
      <Typography
        sx={{
          color: "#020A0D",
          textAlign: "center",
          fontFamily: "Inter",
          fontWeight: 600,
          fontSize: { xs: "19px", sm: "28px", md: "2.5rem" },
          lineHeight: "2.5rem",
        }}
      >
        Why Xane?
      </Typography>
      {/* why xane Card 1 */}
      <Box
        sx={{
          width: "100%",
          display: "flex",
          flexDirection: { xs: "column", sm: "row", md: "row" },
          alignItems: "center",
          justifyContent: "center",
          alignSelf: "stretch",
          gap: { xs: "22px", md: "24px" },
          borderRadius: "30px",
          background: "#EBF5F9",
          alignContent: "center",
          padding: { xs: "20px", sm: "0px 0px 0px 40px", md: "0px 0px 0px 40px" },
          position: "relative",
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: { xs: " 12px", md: "48px" },
            flex: "1 0 0",
          }}
        >
          <Typography
            sx={{
              color: "#020A0D",
              fontFamily: "Inter",
              fontWeight: 500,
              lineHeight: 1.4,
              fontSize: { xs: "19px", sm: "28px", md: "40px" },
              transform: "rotate(0.103deg)",
              alignSelf: "stretch",
              textAlign: { xs: "center", sm: "start", md: "start" },
            }}
          >
            Breakdowns happen anytime. <br /> But, diagnostics only sometimes
          </Typography>
          {!isMobile && (
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "flex-start",
                gap: "20px",
                alignSelf: "stretch",
                width: { sm: "100%", md: "90%" },
              }}
            >
              <Typography
                sx={{
                  color: "#68696B",
                  fontFamily: "Inter",
                  fontWeight: 300,
                  fontSize: { sm: "13px", md: "1.1875rem" },
                  lineHeight: 1.4,
                }}
              >
                Current assistance workflows are broken. Paper manuals & service networks are
                inaccessible. Customers find it stressful to get accurate, reliable & timely info to
                deal with simple to complex queries!
              </Typography>
              <Typography
                sx={{
                  color: "#68696B",
                  fontFamily: "Inter",
                  fontWeight: 300,
                  fontSize: { sm: "13px", md: "1.1875rem" },
                  lineHeight: 1.4,
                }}
              >
                Xane offers scan-to-diagnose assistance flows that are product-SKU specific and also
                connected with your brand’s service networks.
              </Typography>
            </Box>
          )}
        </Box>
        <Box
          sx={{
            width: { xs: "100%", sm: "277px", md: "370px" },
            height: { xs: "300px", sm: "440px", md: "550px" },
            borderRadius: { sm: "17.6px", md: "22px" },
          }}
        >
          <CardMedia
            component="video"
            autoPlay
            loop
            muted
            src={whyxane1}
            sx={{
              backgroundL: "transparent",
              height: "100%",
              width: "100%",
              objectFit: "cover",
              borderRadius: { sm: "17.6px", md: "22px" },
            }}
          />
        </Box>
      </Box>
      {/* 2nd card */}
      <Box
        sx={{
          width: "100%",
          display: "flex",
          flexDirection: { xs: "column", sm: "row", md: "row-reverse" },
          alignItems: "center",
          justifyContent: "center",
          alignSelf: "stretch",
          gap: { xs: "22px", md: "24px" },
          borderRadius: "30px",
          background: "#FEF0E7",
          alignContent: "center",
          padding: { xs: "20px", sm: "0px 0px 0px 40px", md: "0px 40px 0px 0px" },
          position: "relative",
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: { xs: " 12px", md: "48px" },
            flex: "1 0 0",
          }}
        >
          <Typography
            sx={{
              color: "#020A0D",
              fontFamily: "Inter",
              fontWeight: 500,
              lineHeight: 1.4,
              fontSize: { xs: "19px", sm: "28px", md: "40px" },
              transform: "rotate(0.103deg)",
              alignSelf: "stretch",
              textAlign: { xs: "center", sm: "start", md: "start" },
            }}
          >
            Customers have questions 24*7.
            <br />
            But difficult to answer & costs $$
          </Typography>
          {!isMobile && (
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "flex-start",
                gap: "20px",
                alignSelf: "stretch",
                width: { sm: "100%", md: "90%" },
              }}
            >
              <Typography
                sx={{
                  color: "#68696B",
                  fontFamily: "Inter",
                  fontWeight: 300,
                  fontSize: { sm: "13px", md: "1.1875rem" },
                  lineHeight: 1.4,
                }}
              >
                Product-onboardings never seem complete. Customers are not equipped to deal with new
                & complex features, reducing product’s perceived value.
              </Typography>
              <Typography
                sx={{
                  color: "#68696B",
                  fontFamily: "Inter",
                  fontWeight: 300,
                  fontSize: { sm: "13px", md: "1.1875rem" },
                  lineHeight: 1.4,
                }}
              >
                Xane offers engagement-tech for all queries & features. Answer whenever needed at
                fraction of cost within your customer’s hands!
              </Typography>
            </Box>
          )}
        </Box>
        <Box
          sx={{
            width: { xs: "100%", sm: "277px", md: "370px" },
            height: { xs: "300px", sm: "440px", md: "550px" },
            borderRadius: { sm: "17.6px", md: "22px" },
          }}
        >
          <CardMedia
            component="video"
            autoPlay
            loop
            muted
            src={whyxane2}
            sx={{
              backgroundL: "transparent",
              height: "100%",
              width: "100%",
              objectFit: "cover",
              borderRadius: { sm: "17.6px", md: "22px" },
            }}
          />
        </Box>
      </Box>
      {/* 3nd card */}
      <Box
        sx={{
          width: "100%",
          display: "flex",
          flexDirection: { xs: "column", sm: "row", md: "row" },
          alignItems: "center",
          justifyContent: "center",
          alignSelf: "stretch",
          gap: { xs: "22px", md: "24px" },
          borderRadius: "30px",
          background: "#E0E1DC",
          alignContent: "center",
          padding: { xs: "20px", sm: "0px 0px 0px 40px", md: "0px 0px 0px 40px" },
          position: "relative",
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: { xs: " 12px", md: "48px" },
            flex: "1 0 0",
          }}
        >
          <Typography
            sx={{
              color: "#020A0D",
              fontFamily: "Inter",
              fontWeight: 500,
              lineHeight: 1.4,
              fontSize: { xs: "19px", sm: "28px", md: "40px" },
              transform: "rotate(0.103deg)",
              alignSelf: "stretch",
              textAlign: { xs: "center", sm: "start", md: "start" },
            }}
          >
            Post-sales funnels are leaky. <br /> But, only without using Xane!
          </Typography>
          {!isMobile && (
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "flex-start",
                gap: "20px",
                alignSelf: "stretch",
                width: { sm: "100%", md: "90%" },
              }}
            >
              <Typography
                sx={{
                  color: "#68696B",
                  fontFamily: "Inter",
                  fontWeight: 300,
                  fontSize: { sm: "13px", md: "1.1875rem" },
                  lineHeight: 1.4,
                }}
              >
                Lack of digital interface can affect brand-authorized channel’s reach at the right
                moment, especially for lucrative service revenue streams
              </Typography>
              <Typography
                sx={{
                  color: "#68696B",
                  fontFamily: "Inter",
                  fontWeight: 300,
                  fontSize: { sm: "13px", md: "1.1875rem" },
                  lineHeight: 1.4,
                }}
              >
                Retain users and increase customer conversions by up-selling products and services
                using in-built paywalls and effective tools.
              </Typography>
            </Box>
          )}
        </Box>
        <Box
          sx={{
            width: { xs: "100%", sm: "277px", md: "370px" },
            height: { xs: "100%", sm: "440px", md: "550px" },
            borderRadius: { sm: "17.6px", md: "22px" },
          }}
        >
          <CardMedia
            component="video"
            autoPlay
            loop
            muted
            src={whyxane3}
            sx={{
              backgroundL: "transparent",
              height: "100%",
              width: "100%",
              objectFit: "cover",
              borderRadius: { sm: "17.6px", md: "22px" },
            }}
          />
        </Box>
      </Box>
    </Box>
  );
}
